import { getShiftTypeFromStartTime } from "../../utils/dateUtils";
import type { NurseInShift, ShiftType, WeekData } from "../../utils/models";

/**
 * Nurses scheduled on `dayIndex` that belong in a given Morning/Night row of the weekly printout.
 *
 * Pulls nurses from EVERY shift slot for that day and keeps only those whose actual start time
 * maps to `rowShiftType` (via the shared getShiftTypeFromStartTime). The slot a nurse is stored in
 * is irrelevant: a nurse parked in the day slot (weeklyShifts[0]) but working night hours is
 * returned for the Night row, and vice versa.
 */
export const getNursesForShiftRow = (week: WeekData, dayIndex: number, rowShiftType: ShiftType): NurseInShift[] =>
	week.weeklyShifts.flatMap((shift) => shift.days[dayIndex]?.nurses ?? []).filter((nurse) => getShiftTypeFromStartTime(nurse.startTime) === rowShiftType);
